export const setApiData = (data) => ({
    type: 'SET_API_DATA',
    payload: data,
  });
  